function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "currentColor",
  d: "M483.8,46.25H181.6c-0.6,0-1.2,0.5-1.2,1.2v28.3c0,0.6,0.5,1.2,1.2,1.2h302.2c0.6,0,1.2-0.5,1.2-1.2v-28.3 C485,46.75,484.5,46.25,483.8,46.25z"
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 71.5,
  cy: 253.35,
  r: 37.9
}), React.createElement("circle", {
  fill: "currentColor",
  cx: 71.5,
  cy: 419.55,
  r: 38.1
}), React.createElement("path", {
  fill: "currentColor",
  d: "M181.6,128.15h142.8c0.6,0,1.2-0.5,1.2-1.2v-28.3c0-0.6-0.5-1.2-1.2-1.2H181.6c-0.6,0-1.2,0.5-1.2,1.2v28.3 C180.5,127.65,181,128.15,181.6,128.15z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M483.8,212.45H181.6c-0.6,0-1.2,0.5-1.2,1.2v28.3c0,0.6,0.5,1.2,1.2,1.2h302.2c0.6,0,1.2-0.5,1.2-1.2v-28.3 C485,212.95,484.5,212.45,483.8,212.45z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M181.6,294.35h142.8c0.6,0,1.2-0.5,1.2-1.2v-28.3c0-0.6-0.5-1.2-1.2-1.2H181.6c-0.6,0-1.2,0.5-1.2,1.2v28.3 C180.5,293.75,181,294.35,181.6,294.35z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M483.8,378.55H181.6c-0.6,0-1.2,0.5-1.2,1.2v28.3c0,0.6,0.5,1.2,1.2,1.2h302.2c0.6,0,1.2-0.5,1.2-1.2v-28.3 C485,379.05,484.5,378.55,483.8,378.55z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M324.4,429.85H181.6c-0.6,0-1.2,0.5-1.2,1.2v28.3c0,0.6,0.5,1.2,1.2,1.2h142.8c0.6,0,1.2-0.5,1.2-1.2v-28.3 C325.6,430.35,325.1,429.85,324.4,429.85z"
}), React.createElement("polygon", {
  fill: "currentColor",
  points: "53.4,86.55 27.3,60.25 0,87.45 26.2,113.65 53.3,140.95 80.5,113.85 143,51.75 115.9,24.45  "
})));

var SvgListing = function SvgListing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485 485",
    style: {
      enableBackground: "new 0 0 485 485"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgListing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/listing.39a36578.svg";
export { ForwardRef as ReactComponent };